exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dflex{\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n}\n.dflex.flex-wrap{\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-flex-wrap: wrap;\n}\n.flex-row{\n\t-ms-flex-direction: row;\n\t    flex-direction: row;\n}\n.flex{\n\t-ms-flex: 1;\n\t    flex: 1;\n\t-webkit-flex: 1;\n}\n.flex2{\n\t-ms-flex: 2;\n\t    flex: 2;\n\t-webkit-flex: 2;\n}\n.list-group{\n\n}\n.list-group .list-group-item{\n    border: 1px solid #d1d1d1;\n    border-radius: 0px;\n    border-right-width: 0px;\n}\n.list-group .list-group-item:first-child{\n\tborder-radius: 4px 0px 0px 4px;\n}\n.list-group .list-group-item:last-child{\n\tborder-radius: 0px 4px 4px 0px;\n\tborder-right-width: 1px;\n}\n\n/*  */\ntable.details-lt tr th, table.details-lt tr td{\n\ttext-align: center;\n}\n\n/* \n */\n\ncanvas.doughReponsive {\n    width: 100% !important;\n    height: auto !important;\n}\n@media screen and (max-width: 768px) {\n\t.dlfex.flex-media{\n\t\t-ms-flex-direction: column;\n\t\t    flex-direction: column;\n\t}\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/statistic/list/list.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/statistic/list/list.component.css
// module chunks = 3